<script lang="ts">
  import { Icons } from '$lib/components/common/icon';
  import { twMerge } from 'tailwind-merge';
  export let disabled: boolean = false;
  export let value: string = '';
  export let inputClass = '';
  export let iconClass = '';
  export let iconSize = '16px';
  export let isExpandable = false;
  let classname = '';
  export { classname as class };
  export let onClick = () => {};
  export let onChange = (_val: string) => {};
  export let onInput = (_val: string) => {};

  $: focused = false;
  $: hasValue = !!value;

  const toggleFocus = (toggle: boolean) => {
    focused = toggle;
  };
  const onFocus = () => {
    toggleFocus(true);
  };
  const onBlur = () => {
    toggleFocus(false);
  };
</script>

<div
  class={twMerge('alii-search-box relative inline-flex h-8 items-center justify-start gap-2 rounded-lg border border-surface-600 bg-white p-2 hover:bg-surface-500', classname)}
  class:disabled
  class:focused
>
  <input
    type="text"
    class={twMerge(
      `input h-6 rounded-none border-none bg-transparent px-1 !pl-[28px] text-[12px] font-medium leading-normal text-[color:var(--text1)]
    placeholder:font-light
    placeholder:[color:var(--text2)]
    focus-within:border-none
    focus:border-none
    focus:brightness-100
    `,
      inputClass,
      isExpandable && `w-[200px] transition-width duration-300 focus:w-[200px]`,
      isExpandable && hasValue && `w-[200px]`
    )}
    on:focus={onFocus}
    on:blur={onBlur}
    on:click={onClick}
    on:change={() => {
      onChange(value);
    }}
    on:input={() => {
      onInput(value);
    }}
    bind:value
    {disabled}
    placeholder={'Search'}
  />

  <span class={`pointer-events-none absolute left-[12px] z-[2] select-none text-[color:var(--text2)] ${iconClass}`}>
    <svelte:component this={Icons['search']} size={iconSize} />
  </span>
</div>

<style lang="postcss">
  @import '$lib/theme/_colours.postcss';
  .alii-search-box:hover > input {
    @apply text-primary-500;
  }
  .alii-search-box.focused {
    @apply border border-[var(--text2)];
  }
  .alii-search-box.focused > input {
    @apply text-primary-500 brightness-100;
  }
  .alii-search-box.disabled {
    @apply cursor-not-allowed bg-[var(--inputDisabledBackground)] text-[color:var(--text1)];
  }
  .alii-search-box.disabled:hover > input {
    @apply text-primary-500;
  }
</style>
